// extracted by mini-css-extract-plugin
module.exports = {"container":"Header_container__j_FN-","img":"Header_img__10phC","link":"Header_link__33Btk"};